<div class="add-section" [ngClass]="currLang == 'en' ? 'add-section-ltr' : 'add-section-rtl'">
    <div class="header-wrapper">
        <div class="title">
            <span (click)="back()">
                <svg [ngStyle]="{'transform': currLang == 'en' ? 'rotate(0)' : 'rotate(180deg)'}" xmlns="http://www.w3.org/2000/svg" width="7" height="14" viewBox="0 0 7 14" fill="none">
                    <path
                        d="M0.333284 7.00009C0.332865 6.78591 0.407459 6.57834 0.544117 6.41342L5.12745 0.913423C5.28304 0.726225 5.50663 0.608502 5.74902 0.586154C5.99141 0.563806 6.23275 0.638663 6.41995 0.794257C6.60715 0.94985 6.72487 1.17344 6.74722 1.41583C6.76957 1.65822 6.69471 1.89956 6.53912 2.08676L2.43245 7.00009L6.39245 11.9134C6.46859 12.0072 6.52546 12.1151 6.55977 12.2309C6.59408 12.3467 6.60517 12.4681 6.59239 12.5883C6.57961 12.7084 6.54322 12.8248 6.48531 12.9308C6.4274 13.0368 6.34912 13.1303 6.25495 13.2059C6.1607 13.2899 6.05012 13.3535 5.93016 13.3927C5.81019 13.4319 5.68341 13.4459 5.55777 13.4339C5.43213 13.4218 5.31033 13.384 5.2 13.3227C5.08968 13.2614 4.9932 13.1779 4.91662 13.0776L0.489117 7.57759C0.374061 7.40793 0.319194 7.2046 0.333284 7.00009Z"
                        fill="#707070" />
                </svg>
            </span>
            <span *ngIf="mode == 'add'">
                {{'school-management.sections.add-section.add-section-title' | translate}}
            </span>
            <span *ngIf="mode == 'edit'">
                {{'school-management.sections.add-section.edit-section-title' | translate}}
            </span>
        </div>
        <button class="save-btn" (click)="saveSection()" [ngClass]=" selectedGrades.length == 0 || sectionName.length == 0 ? 'disabled' : 'enabled'" [disabled]="selectedGrades.length == 0 || sectionName.length == 0">
            {{'school-management.sections.add-section.save-btn' | translate}}
        </button>
    </div>

    <div class="body-wrapper">
        <div class="row">
            <div class="col-lg-6 section-name">
                <!-- ng-invalid ng-dirty -->
                <input pInputText class="" [(ngModel)]="sectionName"
                    placeholder="{{'school-management.sections.add-section.section-name' | translate}}" (change)="onNameChange($event)" />
            </div>
            <div class="col-lg-6">
                <div class="grade-wrapper">
                    <p-multiSelect #multiSelect [options]="allGrades" [(ngModel)]="selectedGrades"
                        (onChange)="onGradeSelectionChange($event)"
                        defaultLabel="{{'school-management.sections.add-section.section-grades' | translate}}"
                        [disabled]="false"
                        emptyMessage="{{'school-management.sections.add-section.no-results' | translate}}"
                        emptyFilterMessage="{{'school-management.sections.add-section.no-results' | translate}}">
                        <!-- display="chip" -->
                    </p-multiSelect>
                </div>
            </div>
        </div>
    </div>
</div>
<app-error-msg></app-error-msg>